module.exports = __webpack_public_path__ + "img/check-circle.35e623b.svg";